<template lang="pug">
  v-footer(
    v-if='deferredPrompt'
    dark fixed
    color='var(--bg-secondary-color)'
    style="margin-left:auto; margin-right:auto; height: 150px; max-width: 500px; z-index: 10"
  ).pa-3
    v-row()
      v-col(cols=12)
        h5(
          v-html="$t('message.pwa-install')"
          style="font-size: 14px"
        )
      v-col(cols=12)
        v-row(justify="end").action-row
          v-btn(text @click='dismiss') {{ $t('dismiss') }}
          v-btn(text @click='install') {{ $t('install') }}

</template>
<script>
import * as c from '@/const/setTimeOutConfig'
export default {
  data: () => ({
    deferredPrompt: null
  }),
  mounted () {
    this.load()
  },
  methods: {
    load () {
      const pwaTimeStampAlert = localStorage.getItem('pwaAlert')
      
      if(pwaTimeStampAlert 
        && parseInt(pwaTimeStampAlert) > parseInt(Date.now()) 
      ) {
        return
      }

      if("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/service-worker.js").then(reg => {
            console.log("Registration succesful, scope: " + reg.scope);
        })
        .catch(err => {
            throw err
        })
      }
      
      window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
      });

      window.addEventListener("appinstalled", () => {
        //reset remain prompt
        this.deferredPrompt = null;
      });

      // if (!window.matchMedia('(display-mode: standalone)').matches) { 
      //   this.deferredPrompt.prompt();
      // }
    },
    dismiss () {
      const timeExpire = Date.now()+c.PWAALERT
      
      this.deferredPrompt = null;
      localStorage.setItem('pwaAlert',timeExpire)  
    },
    async install () {
      this.deferredPrompt.prompt();
    }
  }
}
</script>

<style scoped> 
.action-row > * {
  width: unset !important;
}
</style>